/* eslint-disable @typescript-eslint/no-explicit-any */
import { Loading3QuartersOutlined } from "@ant-design/icons";
import { Button, Calendar, Flex, Select, Spin } from "antd";
import { SelectArrow, TickIcon } from "../../../../atoms/CustomIcons";
import dayjs from "dayjs";

import "dayjs/locale/zh-cn";

import type { CalendarProps } from "antd";
import type { Dayjs } from "dayjs";
import dayLocaleData from "dayjs/plugin/localeData";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../config/hooks";
import { rescheduleRemainingVisits } from "../../ducks/services";
import { AxiosError } from "axios";
import { SuccessMessage } from "../../../../atoms/Toasts/SuccessMessage";
import { ErrorMessage } from "../../../../atoms/Toasts/ErrorMessage";
import { getScheduleByDay, getSchedulingFormData } from "../../ducks/actions";

dayjs.extend(dayLocaleData);

const antIcon = <Loading3QuartersOutlined spin />;

interface PropsType {
  onClose: () => void;
  btnApi: () => void;
  scheduleId?: string;
  crewId?: string | null;
  loading: boolean;
  setLoading?: (loading: boolean) => void;
  oldDate?: Dayjs | null;
  crewOptions?: { label: string; value: string }[];
  weekStartDate?: Dayjs | null;
}

const RescheduleRemainingOrWhole = (props: PropsType) => {
  const {
    onClose,
    loading,
    scheduleId,
    crewId,
    setLoading,
    oldDate,
    crewOptions,
    weekStartDate,
  } = props;
  const dispatch = useAppDispatch();
  const [crewLeaderId, setCrewLeaderId] = useState<string | null>(null);
  const [selectedDate, setSelectedDate] = useState<Dayjs | null>(dayjs());
  const [crewLeaderList, setCrewLeaderList] = useState<
    { label: string; value: string }[]
  >([]);

  const schedulingFiltersData = useAppSelector(
    (state) => state?.schedule?.schedulingFiltersData
  );

  useEffect(() => {
    if (schedulingFiltersData?.data) {
      const crewList = schedulingFiltersData?.data?.crews?.map((crew: any) => ({
        label: crew?.name,
        value: crew?.id,
      }));
      const seen = new Set<string>();
      for (let i = crewList?.length - 1; i >= 0; i--) {
        const val = crewList[i].value;
        if (seen?.has(val)) {
          crewList?.splice(i, 1);
        } else {
          seen?.add(val);
        }
      }
      setCrewLeaderList(crewList);
    }
  }, [schedulingFiltersData?.data]);

  const onCloseHandler = () => {
    onClose();
  };

  const onPanelChange = (value: Dayjs, mode: CalendarProps<Dayjs>["mode"]) => {
    console.log(value.format("YYYY-MM-DD"), mode);
  };
  console.log("scheduleId", scheduleId);
  const unscheduleApi = () => {
    setLoading && setLoading(true);
    const payload = {
      schedule_id: scheduleId,
      date: dayjs(selectedDate).format("YYYY-MM-DD"),
      crew_id: crewLeaderId ?? crewId,
    };
    console.log("Reschedule payload", payload);
    rescheduleRemainingVisits(payload)
      .then(() => {
        setLoading && setLoading(false);
        SuccessMessage("Rescheduled successfully");
        const formattedDate = dayjs(oldDate).format("YYYY-MM-DD");
        dispatch(getScheduleByDay(formattedDate));
        const payload = {
          date: dayjs(weekStartDate).format("YYYY-MM-DD"),
        };
        dispatch(getSchedulingFormData(payload));
        onClose();
      })
      .catch((e: unknown) => {
        if (e instanceof AxiosError) {
          setLoading && setLoading(false);
          ErrorMessage(
            e?.response?.data?.error?.message ?? "Something went wrong"
          );
        } else {
          setLoading && setLoading(false);
          ErrorMessage("Something went wrong");
        }
      });
    console.log("crewLeaderId, selectedDate", crewLeaderId, selectedDate);
  };

  return (
    <Spin indicator={antIcon} size="large" spinning={loading}>
      <div className="modalWrapper rescheduleWrapper">
        <div className="modal_header">
          <div className="title">
            <h3> Reschedule visits </h3>
            <p style={{ color: "#151718" }}>
              Select date and crew to reschedule it to.
            </p>
          </div>
        </div>

        <div className="modal_content">
          <div className="crewLeaderDrop">
            <Select
              style={{ width: "100%" }}
              suffixIcon={<SelectArrow />}
              menuItemSelectedIcon={<TickIcon style={{ color: "#00A07D" }} />}
              showSearch
              allowClear
              placeholder="Select crew"
              options={
                crewLeaderList?.length > 0 ? crewLeaderList : crewOptions
              }
              value={crewLeaderId ? crewLeaderId.toString() : undefined}
              onChange={(value) => setCrewLeaderId(value)}
            />
          </div>
          <div className="reScheduleCalendar">
            <Calendar
              fullscreen={false}
              onPanelChange={onPanelChange}
              value={selectedDate ?? undefined}
              onSelect={(value) => setSelectedDate(value)}
              headerRender={({ value, onChange }) => {
                const year = value.year();
                const month = value.month();

                const yearOptions = Array.from({ length: 20 }, (_, i) => {
                  const label = year - 10 + i;
                  return { label, value: label };
                });

                const monthOptions = value
                  .localeData()
                  .monthsShort()
                  .map((label, index) => ({
                    label,
                    value: index,
                  }));

                return (
                  <Flex
                    gap={8}
                    justify="space-between"
                    align="center"
                    style={{ marginTop: 8 }}
                  >
                    <div className="calendarLeftTop">
                      <Select
                        size="small"
                        popupMatchSelectWidth={false}
                        value={year}
                        options={yearOptions}
                        onChange={(newYear) => {
                          const now = value.clone().year(newYear);
                          onChange(now);
                        }}
                        suffixIcon={<SelectArrow />}
                      />
                      <Select
                        size="small"
                        popupMatchSelectWidth={false}
                        value={month}
                        options={monthOptions}
                        onChange={(newMonth) => {
                          const now = value.clone().month(newMonth);
                          onChange(now);
                        }}
                        suffixIcon={<SelectArrow />}
                      />
                    </div>
                    <div className="calendarRightTop">
                      <Button
                        onClick={() => {
                          const newMonthValue = value
                            .clone()
                            .subtract(1, "month");
                          onChange(newMonthValue);
                        }}
                        icon={<SelectArrow />}
                        className="prevBtn"
                      />
                      <Button
                        onClick={() => {
                          const newMonthValue = value.clone().add(1, "month");
                          onChange(newMonthValue);
                        }}
                        icon={<SelectArrow />}
                        className="nextBtn"
                      />
                    </div>
                  </Flex>
                );
              }}
            />
          </div>
        </div>

        <div className="modal_footer">
          <Button
            htmlType="button"
            className="outlined-btn"
            type="default"
            size="large"
            onClick={onCloseHandler}
          >
            Cancel
          </Button>

          <Button
            htmlType="button"
            className="mint-btn"
            type="primary"
            size="large"
            onClick={unscheduleApi}
            loading={loading}
          >
            Reschedule visits
          </Button>
        </div>
      </div>
    </Spin>
  );
};

export default RescheduleRemainingOrWhole;
